export const messages = {
  en: {
    invoiceApply: {
      searchTitle: 'Search Conditions',
      title: 'Invoicing',
      apply: 'Invoicing',
      table: {
        id: 'ID',
        invoiceKind: 'Invoice Kind',
        invoiceType: 'Invoice Type',
        ownerName: 'Owner Name',
        roomName: 'Room No.',
        applicant: 'Applicant',
        invoiceName: 'Invoice Title',
        taxNumber: 'Taxpayer ID',
        addressPhone: 'Address & Phone',
        amount: 'Amount',
        invoiceCode: 'Invoice Code',
        submitState: 'Submit Result',
        mallState: 'Mall Status',
        failReason: 'Fail Reason',
        applyTime: 'Apply Time',
        invoicePdf: 'Invoice PDF'
      },
      mallState: {
        AUDIT: 'Pending Audit',
        WAIT: 'Pending Issue',
        DONE: 'Issued',
        FAIL: 'Issue Failed',
        RED: 'Red Invoiced'
      },
      submitStateAll: 'All',
      submitStateSubmit: 'Submitted',
      submitStateFail: 'Submit Failed',
      personal: 'Personal',
      company: 'Company',
      invoiceKindAll: 'All',
      invoiceTypeAll: 'All',
      normalInvoice: 'Normal Invoice',
      specialInvoice: 'Special VAT Invoice',
      notUploaded: 'Not Uploaded',
      downloadInvoice: 'Download Invoice',
      noInvoicePdf: 'No Invoice PDF',
      reSubmit: 'Re-submit',
      submitSuccess: 'Submitted',
      submitFailed: 'Submit failed',
      invoiceCodePlaceholder: 'Please enter invoice number',
      invoiceKindPlaceholder: 'Please select invoice kind',
      invoiceTypePlaceholder: 'Please select invoice type',
      ownerNamePlaceholder: 'Please enter owner name',
      applicantPlaceholder: 'Please enter applicant',
      phonePlaceholder: 'Please enter applicant phone',
      roomNamePlaceholder: 'Please enter room number',
      roomFilterTitle: 'Room Filter',
      allRooms: 'All Rooms'
    },
    deleteInvoiceApply: {
      title: 'Confirm Operation',
      confirmMessage: 'Confirm to delete this invoice application?'
    },
    uploadImage: {
      sizeLimit: 'Image size cannot exceed 2MB'
    }
  },
  zh: {
    invoiceApply: {
      searchTitle: '查询条件',
      title: '开票',
      apply: '开票',
      table: {
        id: '编号',
        invoiceKind: '发票种类',
        invoiceType: '发票类型',
        ownerName: '业主名称',
        roomName: '房屋编号',
        applicant: '申请人',
        invoiceName: '发票名头',
        taxNumber: '纳税人识别号',
        addressPhone: '地址、电话',
        amount: '申请金额',
        invoiceCode: '发票号',
        submitState: '提交结果',
        mallState: '商城状态',
        failReason: '失败原因',
        applyTime: '申请时间',
        invoicePdf: '发票PDF'
      },
      mallState: {
        AUDIT: '待审核',
        WAIT: '待开票',
        DONE: '开票成功',
        FAIL: '开票失败',
        RED: '已冲红'
      },
      submitStateAll: '全部',
      submitStateSubmit: '已提交',
      submitStateFail: '提交失败',
      personal: '个人',
      company: '企业',
      invoiceKindAll: '全部',
      invoiceTypeAll: '全部',
      normalInvoice: '普票',
      specialInvoice: '专票',
      notUploaded: '未上传',
      downloadInvoice: '下载发票',
      noInvoicePdf: '暂无发票',
      reSubmit: '重新提交',
      submitSuccess: '已提交',
      submitFailed: '提交失败',
      invoiceCodePlaceholder: '请填写发票号',
      invoiceKindPlaceholder: '请选择发票种类',
      invoiceTypePlaceholder: '请选择发票类型',
      ownerNamePlaceholder: '请填写业主名称',
      applicantPlaceholder: '请填写申请人',
      phonePlaceholder: '请填写申请人电话',
      roomNamePlaceholder: '请填写房屋编号',
      roomFilterTitle: '房屋筛选',
      allRooms: '全部房屋'
    },
    deleteInvoiceApply: {
      title: '请确认您的操作',
      confirmMessage: '确定删除申请发票'
    },
    uploadImage: {
      sizeLimit: '图片大小不能超过 2MB'
    }
  },
  'zh-TW': {
    invoiceApply: {
      searchTitle: '查詢條件',
      title: '開票',
      apply: '開票',
      table: {
        id: '編號',
        invoiceKind: '發票種類',
        invoiceType: '發票類型',
        ownerName: '業主名稱',
        roomName: '房屋編號',
        applicant: '申請人',
        invoiceName: '發票名頭',
        taxNumber: '納稅人識別號',
        addressPhone: '地址、電話',
        amount: '申請金額',
        invoiceCode: '發票號',
        submitState: '提交結果',
        mallState: '商城狀態',
        failReason: '失敗原因',
        applyTime: '申請時間',
        invoicePdf: '發票PDF'
      },
      mallState: {
        AUDIT: '待審核',
        WAIT: '待開票',
        DONE: '開票成功',
        FAIL: '開票失敗',
        RED: '已沖紅'
      },
      submitStateAll: '全部',
      submitStateSubmit: '已提交',
      submitStateFail: '提交失敗',
      personal: '個人',
      company: '企業',
      invoiceKindAll: '全部',
      invoiceTypeAll: '全部',
      normalInvoice: '普票',
      specialInvoice: '專票',
      notUploaded: '未上傳',
      downloadInvoice: '下載發票',
      noInvoicePdf: '暫無發票',
      reSubmit: '重新提交',
      submitSuccess: '已提交',
      submitFailed: '提交失敗',
      invoiceCodePlaceholder: '請填寫發票號',
      invoiceKindPlaceholder: '請選擇發票種類',
      invoiceTypePlaceholder: '請選擇發票類型',
      ownerNamePlaceholder: '請填寫業主名稱',
      applicantPlaceholder: '請填寫申請人',
      phonePlaceholder: '請填寫申請人電話',
      roomNamePlaceholder: '請填寫房屋編號',
      roomFilterTitle: '房屋篩選',
      allRooms: '全部房屋'
    },
    deleteInvoiceApply: {
      title: '請確認您的操作',
      confirmMessage: '確定刪除申請發票'
    },
    uploadImage: {
      sizeLimit: '圖片大小不能超過 2MB'
    }
  }
}
